import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BatteryErrorIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4.63643 20.4707L20.6701 4.43686L19.3974 3.16406L17.2605 5.30092H14.7604V7.10092H15.4605L14.3206 8.24086H6.00022C4.67474 8.24086 3.60022 9.31538 3.60022 10.6409V15.4409C3.60022 16.3929 4.15458 17.2155 4.95811 17.6034L3.36365 19.1979L4.63643 20.4707ZM6.52065 16.0409H6.00022C5.66885 16.0409 5.40022 15.7722 5.40022 15.4409V10.6409C5.40022 10.3095 5.66885 10.0409 6.00022 10.0409H12.5206L6.52065 16.0409ZM5.64026 7.10092H9.24026V5.30092H5.64026V7.10092ZM18.0002 16.0409H11.6045L9.80451 17.8409H18.0002C19.3257 17.8409 20.4002 16.7663 20.4002 15.4409V10.6409C20.4002 9.72186 19.8837 8.9235 19.1251 8.52027L17.6045 10.0409H18.0002C18.3316 10.0409 18.6002 10.3095 18.6002 10.6409V15.4409C18.6002 15.7722 18.3316 16.0409 18.0002 16.0409Z"
      />
    </SvgIcon>
  );
});
